__turbopack_context__.v({
  "active": "NavQuickLinkBannerItem-module-scss-module__tAXFqG__active",
  "wrapper": "NavQuickLinkBannerItem-module-scss-module__tAXFqG__wrapper",
});
